<template>
  <div class="left-chart-2" id="left-chart-2"></div>
</template>

<script>
import { selectInspectEffectiveDateMr } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart2',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const echartsDom = document.getElementById('left-chart-2')
      this.chart = this.$echarts.init(echartsDom)
      const apiData = await selectInspectEffectiveDateMr(this.date)
      const echartsData = []
      if (apiData) {
        apiData.forEach(item => {
          echartsData.push({
            name: item.hxcs_position,
            value: item.yxsysc_yxsysc,
          })
        })
      }
      const options = {
        title: {
          text: '部位检查有效时长情况',
          left: 'center',
          top: '10px',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {},
        legend: {
          type: 'scroll',
          pageIconColor: '#70f3ff',
          pageIconInactiveColor: '#065279',
          bottom: 10,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          bottom: 10,
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['40%', '60%'],
            label: {
              formatter: function(data) {
                return data.percent.toFixed(0) + '%'
              },
              show: true,
              textStyle: {
                color: '#fff',
              },
              position: 'inner',
            },
            insideLabel: {
              show: true,
            },
            labelLine: {
              show: false,
            },
            data: echartsData,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-2 {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
}
</style>
